export default __webpack_public_path__ + "static/media/mybooking.daf6e1dd.jpg";